'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('./utils'),
    getPubsubRouting = _require.getPubsubRouting;

var _require2 = require('../../../utils'),
    withTimeoutOption = _require2.withTimeoutOption;

module.exports = function (_ref) {
  var ipns = _ref.ipns,
      constructorOptions = _ref.options;

  /**
   * Show current name subscriptions.
   *
   * @param {function(Error)} [callback]
   * @returns {Promise<string[]>}
   */
  return withTimeoutOption( /*#__PURE__*/function () {
    var _subs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
      var pubsub;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              pubsub = getPubsubRouting(ipns, constructorOptions);
              return _context.abrupt("return", pubsub.getSubscriptions(options));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function subs(_x) {
      return _subs.apply(this, arguments);
    }

    return subs;
  }());
};